import React from "react";
import { useHistory } from "react-router";
import { ROUTE } from "../../../route/Route";
import moment from "moment";
import ImgPlaceHolder from "../../../constant/imgPlaceholder";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import SectionLoader from "../../LodingScreen/SectionLoader";
import { isAws } from "../../../constant/utils";
import Slider from "react-slick";
import { newsSettings } from "../../../constant/sliderConfig";

function PressRealease(props: any) {
  const { t } = useTranslation();
  const { press, pUri } = props;
  const history = useHistory();
  const pressData: any = useSelector((state: any) =>
    state.dashboard.pressRelease ? state.dashboard.pressRelease : {}
  );
  return (
    <section className="sub-section h-wellness pressRealeaseIndex">
      <div className="container">
        <div className="my-4">
          <div>
            <div className="xs-feature-text-content text-center">
              <div className="xs-heading">
                <h2 className="xs-title">{t("press_release")}</h2>
              </div>
            </div>
          </div>
        </div>

        {Object.keys(pressData).length > 0 && Object.keys(pressData).length > 0 ? (
          <div className="news_slider">
            <Slider {...newsSettings}>
              {press && press.length > 0 ? (
                press?.map((item: any, i: any) => (
                  <div className="gap_slides" key={i}>
                    <div className="h-well mt-well sbg1">
                      <div className="infobox_wrapper for-press-release pt-3">
                        {/* <div className="infobox_icon_container"><img src={item?.Images  && imgPUri ?  `${imgPUri}${item?.Images[0].image}` : "/assets/img/b1.png"} onError={(e:any)=> ImgPlaceHolder(e, "/assets/img/b1.png")} className="scale round_img" alt="" /></div> */}
                        {item?.Images && item?.Images.length > 0 ? (
                          <div className="infobox_icon_container">
                            <img
                              src={
                                item?.Images && Array.isArray(item?.Images) && item?.Images?.length > 0
                                  ? isAws(item?.Images[0].image)
                                    ? `${pUri?.iAWS}${item?.Images[0].image}`
                                    : `${pUri?.iBASE}${item?.Images[0].image}`
                                  : ""
                              }
                              onError={(e: any) => ImgPlaceHolder(e, "")}
                              className="scale round_img"
                              alt="blog-img"
                            />
                          </div>
                        ) : (
                          ""
                        )}
                        <h4 className="infobox_title">{item?.EventTitle}</h4>
                        <p className="time f-18">{item?.Date && moment(item?.Date).format("MMM DD, YYYY")}</p>
                        <p className="f-14">{item?.ShortDetails && item?.ShortDetails?.slice(0, 500)}</p>
                        <Link to={`${ROUTE.PRESSREALEASEDETAIL}/${item?.Slug}`} className="mt-5 button--hexagon1">
                          <span>KNOW MORE</span>
                        </Link>
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <div className="text-left f-16">{t("no_data_available")}</div>
              )}
            </Slider>
          </div>
        ) : (
          <SectionLoader />
        )}
      </div>
    </section>
  );
}

export default PressRealease;
